import React from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { connect, useSelector } from "react-redux";
import { commonStyles } from "../AuthenticationLayout/authenticationLayoutCommonStyling.tailwind";
import Button from "../shared/Button/Button";
import resetPasswordValidationSchema from "./resetPassword.validation";
import routeConstant from "../../lib/constants/routeConstant";
import InputController from "../shared/Input/InputField/InputController";
import { resetPassword } from "../../redux/slices/authSlice";
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader";

const ResetPasswordForm = ({ resetPasswordRequest }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetPasswordToken = searchParams.get('token');

  const { isLoading: isReseting } = useSelector(state => state.auth)

  // controller and state handled by react-router-dom
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(resetPasswordValidationSchema), // Use Yup resolver
  });

  const resetPasswordForm = async(formData) => {
    const data = {
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      token: resetPasswordToken
    }
    const resetRequest = await resetPasswordRequest(data)

    if(resetPassword.fulfilled.match(resetRequest)) {
      navigate(routeConstant.LOGIN_PAGE)
    }
  }

  if(!resetPasswordToken) {
    return <Navigate to={routeConstant.DEFAULT_PAGE} />
  }

  return (
    <div className={commonStyles.sub_container}>
      {isReseting && <OverlayLoader />}
      <form className={commonStyles.form_wrpr} onSubmit={handleSubmit(resetPasswordForm)}>
        {/* Input Fields */}
        <div className={commonStyles.input_fields_wrpr}>
          {/* Password */}
          <InputController
            autoFocus = {true} 
            label="Enter Password"
            type="password"
            name="password"
            control={control}
            error={!!errors.password}
            helperText={errors.password?.message}
          />

          {/* Confirm Password */}
          <InputController
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            control={control}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
          />
        </div>

        {/* Login Button */}
        <Button variant="primary" type="submit" disabled={isReseting} className={commonStyles.loginButton}>{isReseting ? `Resetting...` : `Reset Password`}</Button>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  resetPasswordRequest: (data) => dispatch(resetPassword(data)),
});

export default connect(null, mapDispatchToProps)(ResetPasswordForm);